module.exports = __webpack_public_path__ + "img/lock.7e50c0a9.svg";